export enum PreferredContactMethod {
    Email = "Email",
    Fax = "Fax",
    Phone = "Phone",
}
